import React from 'react';
import { Box, Typography } from '@mui/material';

import { PrimarySkillsRanking } from '@constants';
import { rankingDotColor } from 'theme/ranking';

export const RankingValue: React.FC<{ value: PrimarySkillsRanking | null }> = ({
  value,
}) => {
  if (!value)
    return (
      <Typography variant="body1" color="text.lightGrey">
        Not rated
      </Typography>
    );

  return (
    <Box display="inline-flex" alignItems="baseline" gap={0.75}>
      <Box
        sx={(theme) => ({
          width: '0.5rem',
          height: '0.5rem',
          flexShrink: 0,
          alignSelf: 'center',
          borderRadius: '50%',
          backgroundColor: rankingDotColor(theme.palette)[value],
        })}
      />
      <Typography variant="body1" color="text.primary" noWrap>
        {value}
      </Typography>
    </Box>
  );
};
